import { Primary } from "../primary/Primary.component"
export const Secondary = ({linksData, searchData}) => {
    return(
        <nav id="secondary-nav">
            <Primary linksData={linksData} searchData={searchData} />
        </nav>
    )
}